export default __webpack_public_path__ + "static/media/login-background.68a80585.svg";